// extracted by mini-css-extract-plugin
export default {"invalidTab":"style_invalidTab__XHsxe","invalidTabContent":"style_invalidTabContent__F2B8c"};